import { useState, useEffect, useRef, useContext } from 'react';
import * as MapDataService from '../../../db/mapDataService';
import { BookingContext } from '../../../contexts/bookingContext';
import { isNullOrUndefinedOrEmpty } from '../../common/utilfn';
import { validateGeneralDetailsPage, validatePassengerDetailsPage } from '../../validation/bookingValidation';
import { saveBookingDetails } from "../../../db/bookingDAO";
import { Link } from 'react-router-dom';

function SpecialEventBooking() {

    let { bookingDetails, setBookingDetails, bookingErrors, setBookingErrors } = useContext(BookingContext);

    const [bookingReferenceId, setBookingReferenceId] = useState(null);

    const vehicleOptions = [
        { id: '1001', type: 'Sedan', name: 'Premium Sedan' },
        { id: '1002', type: 'Sedan', name: 'Executive Sedan' },
        { id: '1003', type: 'SUV', name: 'SUV Sport' },
        { id: '1004', type: 'Van', name: 'Van' }
    ];


    function validateBookingDetails() {
        setBookingErrors({});

        let errorFlag = true;
        if (!validateGeneralDetailsPage(bookingDetails, setBookingErrors)) {
            errorFlag = false;
        }
        if (!validatePassengerDetailsPage(bookingDetails, setBookingErrors)) {
            errorFlag = false;
        }
        if (!errorFlag) {
            // Find the first field with an error in bookingErrors
            const firstErrorField = Object.keys(bookingErrors).find((key) => bookingErrors[key]);

            if (firstErrorField) {
                const element = document.getElementById(firstErrorField);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    element.focus();
                }
            }
        }
        return errorFlag;
    }

    const submitEventBooking = async () => {
        let flag = validateBookingDetails();
        if (!flag) {
            return;
        }

        const updatedBookingDetails = {
            ...bookingDetails,
            type: "EVENT_BOOKING",
            bookingStatus: "QUOTE_REQUESTED"
        };

        let response = await saveBookingDetails(updatedBookingDetails);
        if (response === -1) {
            console.log("Error in creating the booking, Please contact the support team.");
            return;
        }
        // 1️⃣ Update context safely
        setBookingDetails((prev) => ({
            ...prev,
            type: "EVENT_BOOKING",
            bookingStatus: "QUOTE_REQUESTED"
        }));
        setBookingReferenceId(response.bookingReferenceId);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        console.log("Booking created successfully, BookingId for ref:" + response.id);
        console.log("Booking created successfully, bookingReferenceId for ref:" + response.bookingReferenceId);
    }

    const [dropdownVisible, setDropdownVisible] = useState(true);
    const [dropdownVisibleForTo, setDropdownVisibleForTo] = useState(true);

    const [autoCompleteResults, setAutoCompleteResults] = useState([]);
    const [autoCompleteResultsForTo, setAutoCompleteResultsForTo] = useState([]);
    const suggestionFromContainerRef = useRef(null);
    const suggestionToContainerRef = useRef(null);

    const [time, setTime] = useState('10:00');

    const handleTimeChange = (newTime) => {
        setTime(newTime);
    };

    const setFromPlaceToBlank = () => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            location: {
                ...prevDetails.location,
                fromPlaceId: '',
                pickupLocation: ''
            }
        }));
    }

    const setToPlaceToBlank = () => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            location: {
                ...prevDetails.location,
                toPlaceId: '',
                dropLocation: ''
            }
        }));

    }

    useEffect(() => {
        if (bookingDetails.bookingStatus === 'QUOTE_REQUESTED') {
            const el = document.getElementById("event-booking-confirmation-div");
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [bookingDetails.bookingStatus]);


    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            let val = bookingDetails.location.pickupLocation;
            if (isNullOrUndefinedOrEmpty(val)) {
                setDropdownVisible(false);
                setFromPlaceToBlank();
                return;
            }
            let addressPredictions = await MapDataService.fetchAddressData(val);
            setAutoCompleteResults(addressPredictions);
        }, 300);

        // Cleanup the timeout on each input change
        return () => clearTimeout(delayDebounceFn);
    }, [bookingDetails.location.pickupLocation]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            let val = bookingDetails.location.dropLocation;

            if (isNullOrUndefinedOrEmpty(val)) {
                setDropdownVisibleForTo(false);
                setToPlaceToBlank();
                return;
            }
            let addressPredictions = await MapDataService.fetchAddressData(val);
            setAutoCompleteResultsForTo(addressPredictions);
        }, 300);
        // Cleanup the timeout on each input change
        return () => clearTimeout(delayDebounceFn);
    }, [bookingDetails.location.dropLocation]);

    // This effect adds a click listener to close the dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (suggestionFromContainerRef.current && !suggestionFromContainerRef.current.contains(event.target)) {
                setDropdownVisible(false);
                setFromPlaceToBlank();
            }
            if (suggestionToContainerRef.current && !suggestionToContainerRef.current.contains(event.target)) {
                setDropdownVisibleForTo(false);
                setToPlaceToBlank();
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleInputChange = (e) => {
        setDropdownVisible(true);
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            location: {
                ...prevDetails.location,
                fromLocationFlag: true,
                pickupLocation: e.target.value,
            }

        }));
    };

    const handleInputChangeForToLocation = (e) => {
        setDropdownVisibleForTo(true);
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            location: {
                ...prevDetails.location,
                fromLocationFlag: false,
                dropLocation: e.target.value,
            }
        }));
    };

    const handleAddressSelection = (placeId, addressValue) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            location: {
                ...prevDetails.location,
                fromPlaceId: placeId,
                pickupLocation: addressValue
            }
        }));
        setDropdownVisible(false);
        setAutoCompleteResults([]);
    };

    const handleAddressSelectionForToLocation = (placeId, addressValue) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            location: {
                ...prevDetails.location,
                toPlaceId: placeId,
                dropLocation: addressValue,
            }
        }));
        setDropdownVisibleForTo(false);
        setAutoCompleteResultsForTo([]);
    };

    const handleBookingDateChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            generalDetails: {
                ...prevDetails.generalDetails,
                bookingDate: event.target.value
            }
        }));
    };

    const handleBookingTimeChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            generalDetails: {
                ...prevDetails.generalDetails,
                bookingTime: event.target.value
            }
        }));
    };

    const handlePassengersCountChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            generalDetails: {
                ...prevDetails.generalDetails,
                passengersCount: event.target.value
            }
        }));
    };

    const handleByTheHourCheckChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            generalDetails: {
                ...prevDetails.generalDetails,
                byTheHourCheck: event.target.checked,
                numberOfHours: 0
            }
        }));

        if (!event.target.checked) {
            setBookingDetails((prevDetails) => ({
                ...prevDetails,
                distanceMatrix: {
                    ...prevDetails.distanceMatrix,
                    changeFlag: !bookingDetails.distanceMatrix.changeFlag
                }
            }));

        }
    };

    const increment = (e) => {
        e.preventDefault();
        let hours = bookingDetails.generalDetails.numberOfHours + 1;
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            generalDetails: {
                ...prevDetails.generalDetails,
                numberOfHours: hours
            }
        }));
    }

    const decrement = (e) => {
        e.preventDefault();
        let hours = bookingDetails.generalDetails.numberOfHours - 0.5;
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            generalDetails: {
                ...prevDetails.generalDetails,
                numberOfHours: hours
            }
        }));
    }

    const today = new Date().toISOString().split('T')[0];

    const handlePassengersFirstNameChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            passengerDetails: {
                ...prevDetails.passengerDetails,
                firstName: event.target.value
            }
        }));
    };

    const handlePassengersLastNameChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            passengerDetails: {
                ...prevDetails.passengerDetails,
                lastName: event.target.value
            }
        }));
    };

    // Handler for updating country code
    const handleCountryCodeChange = (e) => {
        const newCountryCode = e.target.value;
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            passengerDetails: {
                ...prevDetails.passengerDetails,
                countryCode: newCountryCode,
            },
        }));
    };

    const handlePassengersMobileNumberChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            passengerDetails: {
                ...prevDetails.passengerDetails,
                mobileNumber: event.target.value
            }
        }));
    };

    const handlePassengersEmailChange = (event) => {
        setBookingDetails((prevDetails) => ({
            ...prevDetails,
            passengerDetails: {
                ...prevDetails.passengerDetails,
                email: event.target.value
            }
        }));
    };


    const updateVehicleSelection = (vehicle) => {
        setBookingDetails((prev) => ({
            ...prev,
            vehicleSelection: {
                id: vehicle.id,
                type: vehicle.type,
                name: vehicle.name
            }
        }));
    };

    return (
        <>
            {
                bookingDetails.bookingStatus === 'QUOTE_REQUESTED' ? (

                    <div className="container text-center mt-5" id="event-booking-confirmation-div">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="card p-4">
                                    <div className="card-body">
                                        <h1 className="card-title">Thank you for your inquiry!</h1>
                                        <p className="card-text">Our support team will reach to you shortly. <br /> Please take a note of Booking reference Id:
                                            <span className="fw-bold text-dark bg-warning px-2">{bookingReferenceId}</span></p>
                                        <div className="mt-4">
                                            <Link to="/" className="btn btn-primary">
                                                Go to Home
                                            </Link>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) :

                    <section className="wrapper bg-light">
                        <div className="container pb-14 pb-md-16">

                            <div className="row mb-5">
                                <div className="col-md-10 col-lg-12 col-xl-10 col-xxl-9 mx-auto text-center">
                                    <br /><br />
                                    <h3 className="display-3 mb-2">Event Booking</h3>
                                    <p className="fs-15">
                                        Business Class Chauffeur delivers premium chauffeur services with luxury vehicles at competitive pricing. From corporate and airport transfers to weddings, private trips, winery tours, and events, we ensure a smooth, comfortable, and professional travel experience every time.
                                    </p>
                                </div>
                            </div>

                            <fieldset className="step" >
                                <div className="container">
                                    <div className="row grid-view gx-md-8 gx-xl-10 gy-6 gy-lg-0 mb-5">
                                        <div className="col-md-6">
                                            <div className="location-header">
                                                <i className="uil uil-map-marker"></i> <span>FROM</span>
                                            </div>
                                            <div className="form-floating mb-5">
                                                <input type="text" className="form-control" placeholder="Enter a location (for airports type e.g. “Sydney Airport”, “Melbourne Airport”, “Perth Airport” etc)"
                                                    id="pickupLocation" value={bookingDetails.location.pickupLocation} onChange={handleInputChange} />
                                                {dropdownVisible && autoCompleteResults.length > 0 && (
                                                    <div ref={suggestionFromContainerRef} className="suggestion-container">
                                                        {autoCompleteResults.map((prediction) => (
                                                            <div key={prediction.place_id}
                                                                onClick={() => handleAddressSelection(prediction.place_id, prediction.description)}
                                                                className="suggestion-item">
                                                                {prediction.description}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                <label htmlFor="pickupLocation">Pickup location</label>
                                                {bookingErrors.fromPlaceId && (
                                                    <div class="text-danger"> {bookingErrors.fromPlaceId}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="location-header">
                                                <i className="uil uil-map-marker"></i> <span>TO</span>
                                            </div>
                                            <div className="form-floating mb-5">
                                                <input type="text" className="form-control"
                                                    placeholder="Enter a location (for airports type e.g. “Sydney Airport”, “Melbourne Airport”, “Perth Airport” etc)"
                                                    id="dropLocation" value={bookingDetails.location.dropLocation} onChange={handleInputChangeForToLocation} />
                                                {dropdownVisibleForTo && autoCompleteResultsForTo.length > 0 && (
                                                    <div ref={suggestionToContainerRef} className="suggestion-container">
                                                        {autoCompleteResultsForTo.map((prediction) => (
                                                            <div key={prediction.place_id}
                                                                onClick={() => handleAddressSelectionForToLocation(prediction.place_id, prediction.description)}
                                                                className="suggestion-item">
                                                                {prediction.description}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                <label htmlFor="dropLocation">Drop location</label>
                                                {bookingErrors.toPlaceId && (
                                                    <div class="text-danger"> {bookingErrors.toPlaceId}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="form-floating mb-5">
                                                <input type="date" className="form-control" placeholder="Enter date" id="bookingDate"
                                                    value={bookingDetails.generalDetails.bookingDate}
                                                    min={today}
                                                    onClick={(e) => e.target.showPicker()}
                                                    onChange={handleBookingDateChange} />
                                                <label htmlFor="bookingDate">Enter date</label>
                                                {bookingErrors.bookingDate && (
                                                    <div class="text-danger"> {bookingErrors.bookingDate}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">

                                            <div className="form-floating mb-5">
                                                <input type="time"
                                                    className="form-control"
                                                    placeholder="Pickup time"
                                                    id="bookingTime"
                                                    value={bookingDetails.generalDetails.bookingTime}
                                                    onChange={handleBookingTimeChange}
                                                    required />

                                                <label htmlFor="bookingTime">Pickup time</label>
                                                {bookingErrors.bookingTime && (
                                                    <div class="text-danger"> {bookingErrors.bookingTime}</div>
                                                )}

                                            </div>

                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-floating mb-5">
                                                <input type="number" className="form-control" placeholder="Passengers" id="passengersCount"
                                                    value={bookingDetails.generalDetails.passengersCount}
                                                    onChange={handlePassengersCountChange} />
                                                <label htmlFor="passengersCount">Passengers</label>
                                                {bookingErrors.passengersCount && (
                                                    <div class="text-danger"> {bookingErrors.passengersCount}</div>
                                                )}
                                            </div>
                                        </div>

                                        {/* 
                            <div className="col-md-4">
                                <div className="form-floating mb-5">
                                    <select
                                        className="form-select text-dark"
                                        id="carType"
                                        value={bookingDetails.vehicleDetails.carType}
                                        onChange={handleCarTypeChange}
                                    >
                                        <option value="CAR_TYPE">Type of Car</option>
                                        <option value="PREMIUM_SEDAN">Premium Sedan</option>
                                        <option value="EXECUTIVE_SEDAN">Executive Sedan</option>
                                        <option value="LUXURY_SUV">Luxury SUV</option>
                                        <option value="LUXURY_SUV">Luxury Van</option>
                                    </select>

                                    {bookingErrors.carType && (
                                        <div className="text-danger">{bookingErrors.carType}</div>
                                    )}
                                </div>
                            </div>
                        */}

                                        <div className="col-md-4">
                                            <div className="form-floating mb-5">
                                                <select
                                                    className="form-select text-dark"
                                                    value={bookingDetails.vehicleSelection.id || ""}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;

                                                        const selectedVehicle = vehicleOptions.find(
                                                            (v) => String(v.id) === String(selectedId)
                                                        );

                                                        if (selectedVehicle) {
                                                            updateVehicleSelection(selectedVehicle);
                                                        }
                                                    }}
                                                >
                                                    <option value="">Select vehicle</option>

                                                    {vehicleOptions.map((vehicle) => (
                                                        <option key={vehicle.id} value={String(vehicle.id)}>
                                                            {vehicle.name}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>


                                        <div className="col-12">
                                            <div className="form-check form-switch mb-5">
                                                <input className="form-check-input" type="checkbox" role="switch" id="bythehour"
                                                    checked={bookingDetails.generalDetails.byTheHourCheck}
                                                    onChange={handleByTheHourCheckChange} />
                                                <label className="form-check-label" htmlFor="bythehour">By the Hour</label>
                                            </div>
                                        </div>
                                        {bookingDetails.generalDetails.byTheHourCheck && (

                                            <>
                                                <div className="row align-items-center">
                                                    <label htmlFor="counterValue" className="col-auto fw-bold">Number of Hours:</label>

                                                    <div className="col-auto">
                                                        <div className="btn-group">
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={decrement}
                                                                disabled={bookingDetails.generalDetails.numberOfHours <= 0}
                                                            >
                                                                -
                                                            </button>
                                                            <span className="btn btn-outline-secondary btn-sm text-dark">{bookingDetails.generalDetails.numberOfHours}</span>
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={increment}
                                                            >
                                                                +
                                                            </button>
                                                        </div>
                                                        {bookingErrors.numberOfHours && (
                                                            <div class="text-danger"> {bookingErrors.numberOfHours}</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>

                                        )}
                                    </div>

                                    <div className="col-md-6">
                                        <div className="location-header">
                                            <i></i> <span>Booking Notes</span>
                                        </div>
                                        <div className="form-floating mb-5">
                                            <textarea
                                                className="form-control"
                                                placeholder="Enter any special instructions (e.g., specific pickup instructions, preferences)"
                                                value={bookingDetails.generalDetails.specialInstructions}  // Bind the value to bookingDetails
                                                onChange={(e) => setBookingDetails({
                                                    ...bookingDetails,
                                                    generalDetails: {
                                                        ...bookingDetails.generalDetails,
                                                        specialInstructions: e.target.value,  // Update the value when it changes
                                                    },
                                                })}
                                                maxLength="300"
                                                style={{ height: '100px' }}  // Optional: Control the height of the textarea
                                            ></textarea>
                                            <label htmlFor="specialInstructions">Booking Special Instructions (Max 300 characters)</label>
                                            {bookingErrors.specialInstructions && (
                                                <div className="text-danger">{bookingErrors.specialInstructions}</div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </fieldset>

                            <fieldset className="step" >
                                <div className="container">
                                    <div className="row grid-view gx-md-8 gx-xl-10 gy-6 gy-lg-0 mb-5">

                                        <div className="col-12">
                                            <div className="form-heading">
                                                <h3>PASSENGER DETAILS</h3>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-floating mb-4">
                                                <input type="text" className="form-control" placeholder="First Name" id="firstName"
                                                    value={bookingDetails.passengerDetails.firstName}
                                                    onChange={handlePassengersFirstNameChange} />
                                                <label htmlFor="firstName">First Name</label>
                                                {bookingErrors.firstName && (
                                                    <div class="text-danger"> {bookingErrors.firstName}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-floating mb-4">
                                                <input type="text" className="form-control" placeholder="Last Name" id="lastName"
                                                    value={bookingDetails.passengerDetails.lastName}
                                                    onChange={handlePassengersLastNameChange} />
                                                <label htmlFor="lastName">Last Name</label>
                                                {bookingErrors.lastName && (
                                                    <div class="text-danger"> {bookingErrors.lastName}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating mb-4">
                                                {/* Flex container for Country Code and Mobile Number */}
                                                <div className="d-flex align-items-center">
                                                    {/* Country Code Input */}
                                                    <div style={{ flex: '0 0 160px' }} className="form-floating me-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="countryCode"

                                                            value={bookingDetails.passengerDetails.countryCode || '+61'}
                                                            onChange={handleCountryCodeChange}
                                                        />
                                                        <label htmlFor="countryCode">Country Code</label>

                                                    </div>

                                                    {/* Mobile Number Input */}
                                                    <div style={{ flex: '1 1 auto' }} className="form-floating">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="mobileNumber"
                                                            placeholder="Enter mobile number"
                                                            value={bookingDetails.passengerDetails.mobileNumber}
                                                            onChange={handlePassengersMobileNumberChange}
                                                        />
                                                        <label htmlFor="mobileNumber">Mobile Number</label>

                                                    </div>
                                                </div>
                                                {bookingErrors.mobileNumber && (
                                                    <div className="text-danger">{bookingErrors.mobileNumber}</div>
                                                )}
                                                {bookingErrors.countryCode && (
                                                    <div className="text-danger">{bookingErrors.countryCode}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-floating mb-4">
                                                <input type="email" className="form-control" placeholder="Enter email" id="email"
                                                    value={bookingDetails.passengerDetails.email}
                                                    onChange={handlePassengersEmailChange}
                                                />
                                                <label htmlFor="email">Enter email</label>
                                                {bookingErrors.email && (
                                                    <div class="text-danger"> {bookingErrors.email}</div>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </fieldset>

                            <div className="col-12">
                                <input type="submit" onClick={submitEventBooking} className="btn btn-secondary rounded btn-send mb-3" value="Get Booking Quote" />
                                <p className="text-muted"><strong>*</strong> These fields are required.</p>
                            </div>

                        </div>
                    </section>
            }
        </>
    );
}

export default SpecialEventBooking;